import { useState, useEffect } from 'react'
import StatusCard from '../StatusCard'
import { fetchSiteMetric } from 'features/networkAi/api'

import { servicePercentage } from 'features/networkAi/NetworkDashboard/utils/analytics'

import { DEFAULT_SLE_VALUES } from './consts'
import { SpinnerCentered } from 'components/Loader'
import { DateCardPlaceholder } from './styles'

interface DataCardProps {
  siteId: string
  metric: string
  duration: number
  title: string
}

function DataCard({ siteId, metric, duration, title }: DataCardProps) {
  //const [interval, setInterval] = useState(600)
  const [isLoaded, setIsLoaded] = useState(false)
  const [data, setData] = useState(DEFAULT_SLE_VALUES)

  /* eslint-disable */

  useEffect(() => {
    try {
      setIsLoaded(false)
      metricData(siteId, metric, duration)
      //setInterval(600)
    } catch (e) {
      console.log('ERROR COMPONENTDIDMOUNT: ' + e)
      console.log(isLoaded)
    }
  }, [siteId, metric, duration, setIsLoaded])

  const metricData = async (
    siteId: string,
    metric: string,
    duration: number
  ) => {
    let end = Math.round(Date.now() / 1000)
    let start = end - duration

    let dataFetch = await fetchSiteMetric(siteId, metric, start, end)
    try {
      setData(dataFetch.data)
      setIsLoaded(true)
    } catch (err) {
      console.log(err)
    }
  }
  const getDegraded = data.sle.samples.degraded
  const getTotal = data.sle.samples.total
  let percentage = servicePercentage(getDegraded, getTotal)

  return (
    <>
      {isLoaded ? (
        <StatusCard title={title} data={percentage}></StatusCard>
      ) : (
        <DateCardPlaceholder>
          <SpinnerCentered />
        </DateCardPlaceholder>
      )}
    </>
  )
}

export default DataCard
